'use strict';

/**
 *
 * PluginIcon
 *
 */
import React from 'react';
import { Search } from '@strapi/icons';
const PluginIcon = () => /*#__PURE__*/React.createElement(Search, null);
export default PluginIcon;